const fbIcon = `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" aria-hidden="true">
    <g>
      <path d="M400,0C179.09,0,0,179.09,0,400S179.09,800,400,800,800,620.91,800,400,620.91,0,400,0ZM509.06,259.72l-39.54,0c-31,0-37,14.73-37,36.35v47.67h73.93l-9.63,74.66H432.52V610h-77.1V418.42H290.94V343.76h64.47V288.69c0-63.9,39-98.69,96-98.69,27.3,0,50.77,2,57.61,2.94Z"/>
    </g>
  </svg>`;

const widgetName = 'socialNetworkWidget';
let initialized = false;

function initialize() {
  $(`#${widgetName}`).append('<div class="socialTabContainer" role="tablist"></div>');

  $(`#${widgetName}`).on('click keydown', '.socialNetworkTab', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      const tab = $(this).attr('data-social-network-tab');

      $('.socialNetworkTab').removeClass('activeTab');
      $('.socialNetworkTab').attr('aria-selected', false);
      $('.socialFeedContainer').hide();

      $(this).addClass('activeTab');
      $(this).attr('aria-selected', true);
      $(`#${tab}Container`).show();
    }
  });

  initialized = true;
}

function isCurrent(current, widget) {
  if (current) {
    $(`#${widgetName} #${widget}Tab`).addClass('activeTab');
    $(`#${widgetName} #${widget}Tab`).attr('aria-selected', true);
    $(`#${widgetName} #${widget}Container`).show();
  }
}

// FACEBOOK -----------

function facebookfeed(current) {
  const fbPageURL =
    $('.socialNetworkIconFacebook').attr('href') || $('body').addClass('socialwidget-no-data');
  const fbHeight = 350;
  const fbWidth = 385;

  const facebookfeedTab = `
    <a id="facebookfeedTab" class="socialNetworkTab" data-social-network-tab="facebookfeed"  role="tab" aria-selected="false" aria-controls="facebookfeedContainer" tabindex="0" aria-label="Facebook">      
    ${fbIcon}<span>Facebook</span>
    </a>`;

  const facebookfeedContainer = `
    <div id="facebookfeedContainer" class="socialFeedContainer" style="display: none;" role="tabpanel" aria-labelledby="facebookfeedTab">
      <div class="fb-page" data-href="${fbPageURL}" data-width="${fbWidth}" data-adapt-container-width="true" data-height="${fbHeight}" data-small-header="true" data-hide-cover="false" data-show-facepile="false" data-show-posts="true">
        <div class="fb-xfbml-parse-ignore">
          <blockquote cite="${fbPageURL}"><a href="${fbPageURL}">Loading...</a></blockquote>
        </div>
      </div>
    </div>
  `;

  if (!isMobile && !initialized) {
    initialize();
  }

  if (!isMobile) {
    $(`#${widgetName} .socialTabContainer`).append(facebookfeedTab);
    $(`#${widgetName}`).append(facebookfeedContainer);

    isCurrent(current, 'facebookfeed');
  }
}

export { facebookfeed };
